import { Stack, Typography } from "@mui/material";
import ActionModuleEditor from "./ActionModuleEditorFrame";
import { useNavigate, useParams } from "react-router-dom";
import { useLocale } from "../../../hooks/UseLocale";

export default function ActionModuleEditorPage() {
    const { actionModuleId, companyId } = useParams();
    const locale = useLocale();
    const navigate = useNavigate();

    return <Stack style={{ height: "calc(100vh - 144px)", boxSizing: "border-box" }}>
        <Typography variant="h3">ActionModuleWizard</Typography>

        {actionModuleId && <ActionModuleEditor
            actionModuleId={actionModuleId}
            companyId={Number(companyId)} isNew={false}
            onSaved={() => navigate(`/${locale}/superadminarea/actionModules`)}
            onDeleted={() => navigate(`/${locale}/superadminarea/actionModules`)} />
        }
    </Stack>
}